import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import type { QuoteStatus } from '../types';

interface QuoteStatusBadgeProps {
  status: QuoteStatus;
  className?: string;
}

const statusConfig: Record<
  QuoteStatus,
  {
    label: string;
    variant: 'default' | 'secondary' | 'destructive' | 'outline' | 'success' | 'warning';
    className?: string;
  }
> = {
  preparation: { label: 'Preparation', variant: 'secondary', className: 'border-slate-200 bg-slate-100 text-slate-700' },
  sent: { label: 'Sent', variant: 'warning', className: 'border-amber-200 bg-amber-100 text-amber-800' },
  'waiting-po': { label: 'Waiting PO', variant: 'warning', className: 'border-orange-200 bg-orange-100 text-orange-800' },
  approved: { label: 'Approved', variant: 'success', className: 'border-emerald-200 bg-emerald-100 text-emerald-800' },
  confirmed: { label: 'Confirmed', variant: 'success', className: 'border-emerald-200 bg-emerald-100 text-emerald-800' },
  inprogress: { label: 'In Progress', variant: 'default', className: 'border-sky-200 bg-sky-100 text-sky-800' },
  'invoice-ready': { label: 'Invoice Ready', variant: 'default', className: 'border-indigo-200 bg-indigo-100 text-indigo-800' },
  'partially-invoiced': { label: 'Partially Invoiced', variant: 'default', className: 'border-violet-200 bg-violet-100 text-violet-800' },
  invoiced: { label: 'Invoiced', variant: 'success', className: 'border-green-200 bg-green-100 text-green-800' },
  cancelled: { label: 'Cancelled', variant: 'outline', className: 'border-slate-300 bg-white text-slate-600' },
  rejected: { label: 'Rejected', variant: 'destructive', className: 'border-red-200 bg-red-100 text-red-800' },
  expired: { label: 'Expired', variant: 'destructive', className: 'border-red-300 bg-red-100 text-red-900' },
};

export function QuoteStatusBadge({ status, className }: QuoteStatusBadgeProps) {
  const config = statusConfig[status] || { label: status, variant: 'secondary' as const };

  return (
    <Badge variant={config.variant} className={cn(config.className, className)}>
      {config.label}
    </Badge>
  );
}
